import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, Reveal, Eyebrow } from "@/components/Reveal";
import { WaveMark } from "@/components/Illustrations";
import { motion } from "framer-motion";

const Tienda = () => (
  <div data-testid="tienda-page">
    <section className="bg-ink text-cream min-h-[85vh] flex flex-col justify-center px-6 sm:px-12 lg:px-20 pt-24 relative overflow-hidden">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-gold mb-8"
      >
        Tienda · Productos
      </motion.p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl" data-testid="tienda-title">
        <MaskedLines lines={["Próximamente,", "muy pronto."]} delay={0.15} />
      </h1>
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.55 }}
        className="mt-8 max-w-md text-cream/70 leading-relaxed"
        data-testid="tienda-subtitle"
      >
        Estoy preparando una selección de productos y guías con el mismo criterio de siempre: infoproductos,
        fichas técnicas y productos de cuidado elegidos uno a uno.
      </motion.p>
      <Reveal delay={0.3} className="mt-10">
        <Link
          to="/contacto"
          data-testid="tienda-aviso-cta"
          className="inline-flex items-center gap-3 rounded-full border border-gold/50 px-7 py-3.5 font-mono text-xs uppercase tracking-[0.18em] text-gold hover:bg-gold hover:text-ink transition-colors duration-300"
        >
          Avísame cuando esté lista <ArrowRight size={15} />
        </Link>
      </Reveal>
      <WaveMark className="absolute -right-8 bottom-10 w-80 text-gold/10 pointer-events-none" />
    </section>

    <section className="bg-cream px-6 sm:px-12 lg:px-20 py-16 lg:py-24" data-testid="tienda-preview">
      <Eyebrow>Lo que encontrarás</Eyebrow>
      <div className="grid sm:grid-cols-2 gap-px bg-sand border border-sand mt-10 max-w-4xl">
        {[
          ["Infoproductos", "Guías descargables y fichas técnicas de la Técnica NAGI."],
          ["Productos físicos", "Cuidado post-procedimiento y selección profesional."],
        ].map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.1} className="bg-cream">
            <div className="p-8 lg:p-12" data-testid={`tienda-preview-${i}`}>
              <span className="font-mono text-xs text-gold tracking-[0.25em]">0{i + 1}</span>
              <h3 className="font-serif text-2xl mt-4 mb-3">{t}</h3>
              <p className="text-sm text-ink/65 leading-relaxed">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </div>
);

export default Tienda;
